import {
  CALCULATOR_FORM_PAYOUT_METHOD_NAME,
  CALCULATOR_FORM_RECEIVER_GET_NAME,
  CALCULATOR_FORM_SEND_TO_NAME,
  FUNC_DEFAULT,
} from 'constants';
import { checkMaintenance } from 'helpers/maintenance';
import { delay, isEmpty } from 'lodash';
import { numberUtils } from 'utils';
import { ROUNDING_DELAY } from '../const';
import useCalculatorRoundingPublicAPI from './useCalculatorRoundingPublicAPI';
import useCalculatorRoundingStore from './useCalculatorRoundingStore';

const useCalculatorRoundingPublic = () => {
  const { remitRoundingRequest } = useCalculatorRoundingPublicAPI();
  const { setCalculatorRoundingPublicResponse, resetCalculatorRounding } =
    useCalculatorRoundingStore();

  const fetchLookupFee = async ({
    amount,
    getAmount,
    dmCode,
    information,
    isOnlyCurrency,
    countryCode,
    isReceiverField,
  } = {}) => {
    if (isEmpty(countryCode) || isEmpty(dmCode)) return;

    const { currentCurrencySelected, currentRate } = information || {};

    const payload = {
      amount: amount || 0,
      getAmount: getAmount || 0,
      countryCode: countryCode || '',
      currencyCode: isOnlyCurrency
        ? currentCurrencySelected?.currencyCode
        : 'AUD',
      dmCode: dmCode || '',
      rate: currentRate || 0,
    };
    try {
      const remitPayload = {
        ...(isReceiverField
          ? {
              receivingAmount: payload['getAmount'],
            }
          : {
              sendingAmount: payload['amount'],
            }),
        rate: payload['rate'],
        currencyCode: payload['currencyCode'],
        dmCode: payload['dmCode'],
        countryCode: payload['countryCode'],
      };
      const { data } = await remitRoundingRequest(remitPayload);

      if (data) {
        setCalculatorRoundingPublicResponse(data);

        const { fee, remittance, originalFee } = data || {};

        const newInfomation = {
          ...information,
          [CALCULATOR_FORM_SEND_TO_NAME]: remittance?.sendingAmount || 0,
          [CALCULATOR_FORM_RECEIVER_GET_NAME]: remittance?.receivingAmount || 0,
          feeAmount: fee,
        };
        return newInfomation;
      }
    } catch (error) {
      checkMaintenance(error);
      console.error(
        `🔥 useCalculatorRoundingPublic ❌ fetchLookupFee ➡️ ERROR ↩`,
        error?.message,
      );
      setCalculatorRoundingPublicResponse();
    }
  };
  const lookupFee = async ({
    amount,
    getAmount,
    information,
    countryCode,
    isReceiverField,
  } = {}) => {
    if (isEmpty(countryCode)) return;

    const { code: dmCode } =
      information[CALCULATOR_FORM_PAYOUT_METHOD_NAME] || {};

    try {
      const newInformation = await fetchLookupFee({
        amount,
        getAmount,
        dmCode,
        information,
        isOnlyCurrency: true,
        countryCode,
        isReceiverField,
      });

      return newInformation;
    } catch (error) {
      checkMaintenance(error);
      console.error(
        `🔥 useCalculatorRoundingPublic ❌ lookupFee ➡️ ERROR ↩`,
        error?.message,
      );
    }
  };
  const fetchCurrentFee = async (
    information = null,
    setInformation = FUNC_DEFAULT,
    countryCode = '',
    maxSendLimit = 30000,
    isReceiverField = false,
  ) => {
    if (isEmpty(countryCode)) return null;

    let newInformation = { ...information };

    const sendAmount = numberUtils.mathRound(
      newInformation[CALCULATOR_FORM_SEND_TO_NAME] || 0,
    );

    const getReceiverAmount = numberUtils.mathRound(
      newInformation[CALCULATOR_FORM_RECEIVER_GET_NAME] || 0,
    );

    if (!sendAmount) {
      newInformation = { ...newInformation, feeAmount: 0 };

      console.log(
        `⭐ useCalculatorRoundingPublic 👉 fetchCurrentFee ➡️ newInformation 1 ↩`,
        newInformation,
      );
      setInformation(newInformation);

      document.getElementById('root-body').style.overflow = 'hidden';

      delay(resetCalculatorRounding, ROUNDING_DELAY);

      return;
    }

    newInformation = await lookupFee({
      amount: sendAmount,
      getAmount: getReceiverAmount,
      information: newInformation,
      countryCode,
      isReceiverField,
    });

    console.log(
      `⭐ useCalculatorRoundingPublic 👉 fetchCurrentFee ➡️ newInformation 2 ↩`,
      newInformation,
    );
    setInformation(newInformation);

    document.getElementById('root-body').style.overflow = 'hidden';
  };

  return { fetchCurrentFee };
};

export default useCalculatorRoundingPublic;
